import type {
  SupportEmailRouteDeleteApiData,
  SupportEmailRouteDeleteApiResponses,
  SupportEmailRoutePatchApiData,
  SupportEmailRoutePatchApiResponses,
  SupportInboxConnectApiData,
  SupportInboxConnectApiResponses,
  SupportInboxCreateApiData,
  SupportInboxCreateApiResponses,
  SupportInboxDeleteApiData,
  SupportInboxDeleteApiResponses,
  SupportInboxDisconnectApiData,
  SupportInboxDisconnectApiResponses,
  SupportInboxGetApiData,
  SupportInboxGetApiResponses,
  SupportInboxListApiData,
  SupportInboxListApiResponses,
  SupportInboxPatchApiData,
  SupportInboxPatchApiResponses,
  SupportInboxRouteCreateApiData,
  SupportInboxRouteCreateApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getSupportInboxUrls = {
  getPaginatedSupportInboxes: dataEndpoint<SupportInboxListApiData, SupportInboxListApiResponses>({
    getUrl: (queryParams) => apiUrl('support-inboxes/', queryParams)
  }),
  getSupportInbox: dataEndpoint<SupportInboxGetApiData, SupportInboxGetApiResponses>({
    getUrl: ({ inboxId }) => apiUrl(`support-inboxes/${inboxId}/`)
  }),
  postSupportInbox: responseEndpoint<SupportInboxCreateApiData, SupportInboxCreateApiResponses>({
    getUrl: () => apiUrl('support-inboxes/'),
    getBody: (data) => data
  }),
  patchSupportInbox: responseEndpoint<SupportInboxPatchApiData, SupportInboxPatchApiResponses>({
    getUrl: ({ inboxId }) => apiUrl(`support-inboxes/${inboxId}/`),
    getBody: ({ inboxId: _, ...body }) => body
  }),
  deleteSupportInbox: dataEndpoint<SupportInboxDeleteApiData, SupportInboxDeleteApiResponses>({
    getUrl: ({ inboxId }) => apiUrl(`support-inboxes/${inboxId}/`)
  }),
  postSupportInboxRoute: responseEndpoint<SupportInboxRouteCreateApiData, SupportInboxRouteCreateApiResponses>({
    getUrl: ({ inboxId }) => apiUrl(`support-inboxes/${inboxId}/routes/`),
    getBody: ({ inboxId: _, ...body }) => body
  }),
  patchSupportEmailRoute: responseEndpoint<SupportEmailRoutePatchApiData, SupportEmailRoutePatchApiResponses>({
    getUrl: ({ routeId }) => apiUrl(`support-email-routes/${routeId}/`),
    getBody: ({ routeId: _, ...body }) => body
  }),
  deleteSupportEmailRoute: dataEndpoint<SupportEmailRouteDeleteApiData, SupportEmailRouteDeleteApiResponses>({
    getUrl: ({ routeId }) => apiUrl(`support-email-routes/${routeId}/`)
  }),
  postSupportInboxConnect: responseEndpoint<SupportInboxConnectApiData, SupportInboxConnectApiResponses>({
    getUrl: ({ inboxId }) => apiUrl(`support-inboxes/${inboxId}/connect/`)
  }),
  deleteSupportInboxConnection: dataEndpoint<SupportInboxDisconnectApiData, SupportInboxDisconnectApiResponses>({
    getUrl: ({ inboxId }) => apiUrl(`support-inboxes/${inboxId}/connection/`)
  })
};
